import { Component, OnInit } from '@angular/core';
import { AdminService } from '../../services/admin.service';
import { AuthService } from 'src/app/auth-module/services/auth.service';
import Swal from 'sweetalert2';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-cse-facility-mapped',
  templateUrl: './cse-facility-mapped.component.html',
  styleUrls: ['./cse-facility-mapped.component.scss']
})
export class CseFacilityMappedComponent implements OnInit {
  // columnNames = ['S.No.', 'Name of CSE', 'Name of facility'];
  columnList = [
    {
      name: 'S.No.',
      textAlign: 'center',
    },
    {
      name: 'Name of CSE',
      textAlign: 'start',
      paddingLeft: '30px',
    },
    {
      name: 'Name of Facility',
      textAlign: 'start',
    },
  ]

  tableData = []
  cseParams: string = ''
  showFilterContainer: boolean = false;
  // name = '';
  facility_name = '';
  stateList = [];
  totalData: any;
  queryParams: any;
  // searchCSE = '';
  searchFacility = '';
  csvDownloadAPI = 'master/cse/map_csv';
  csvFileName = 'cse-facility-mapped';
  downloadCSVParams = ''

  constructor(private adminService: AdminService,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location) {
    this.queryParams = this.route.snapshot.queryParams
    let q = Object.keys(this.queryParams)
    if (q.length > 0) {
      let decodedStr = atob(`${q[0]}`);
      // console.log('qq', decodedStr);
      let properties = decodedStr.split('&');
      let obj = {};
      properties.forEach(function (property) {
        let tup = property.split('=');
        obj[tup[0]] = tup[1];
      });
      this.queryParams = obj;
    }

    // console.log('after decrypted in cse facility', this.queryParams);
    
    this.downloadCSVParams = `${this.cseParams}&cseId=${this.queryParams.userId}`
      
    if (sessionStorage.getItem('isClearFilter') == 'true') {
      sessionStorage.removeItem('search_name_cse-facility_map');
      // sessionStorage.removeItem('filter_name_cse-facility_map');
      sessionStorage.removeItem('filter_facility_name__cseFacilityMap');
    }
    
  }
  
  ngOnInit(): void {
    // if (sessionStorage.getItem('search_name_cse-facility_map') !== null) {
    //   this.cseParams = `cse_name=${sessionStorage.getItem('search_name_cse-facility_map')}`;
    //   this.searchFacility = sessionStorage.getItem('search_name_cse-facility_map');
    // } else if (sessionStorage.getItem('filter_name_cse-facility_map') !== null || sessionStorage.getItem('filter_facility_name__cseFacilityMap') !== null) {
    //   this.cseParams = `cse_name=${sessionStorage.getItem('filter_name_cse-facility_map') !== null ? sessionStorage.getItem('filter_name_cse-facility_map') : ''}&facility_name=${sessionStorage.getItem('filter_facility_name__cseFacilityMap') !== null ? sessionStorage.getItem('filter_facility_name__cseFacilityMap') : ''}`;
    //   if (sessionStorage.getItem('filter_name_cse-facility_map') !== null) {
    //     this.name = sessionStorage.getItem('filter_name_cse-facility_map');
    //   }
    //   if (sessionStorage.getItem('filter_facility_name__cseFacilityMap') !== null) {
    //     this.facility_name = sessionStorage.getItem('filter_facility_name__cseFacilityMap');
    //   }
    //   this.showFilterContainer = true;

    // }
    // this.getCSEMappedListDeatils();

    if (sessionStorage.getItem('search_name_cse-facility_map') !== null) {
      this.cseParams = `facility_name=${sessionStorage.getItem('search_name_cse-facility_map')}`;
    this.downloadCSVParams = `${this.cseParams}&cseId=${this.queryParams.userId}`
      this.searchFacility = sessionStorage.getItem('search_name_cse-facility_map');
    } else if (sessionStorage.getItem('filter_facility_name__cseFacilityMap') !== null) {
      this.cseParams = `facility_name=${sessionStorage.getItem('filter_facility_name__cseFacilityMap') !== null ? sessionStorage.getItem('filter_facility_name__cseFacilityMap') : ''}`;
      this.downloadCSVParams = `${this.cseParams}&cseId=${this.queryParams.userId}`
      if (sessionStorage.getItem('filter_facility_name__cseFacilityMap') !== null) {
        this.facility_name = sessionStorage.getItem('filter_facility_name__cseFacilityMap');
      }
      this.showFilterContainer = true;

    }
    this.getCSEMappedListDeatils();
  }


  getCSEMappedListDeatils() {
    this.tableData = [];
    // console.log(this.cseParams);
    let id = this.queryParams.userId;
    let params = `${this.cseParams}&limit=10`;
    this.adminService.mappedCseFacility(id, params, sessionStorage.getItem("token")).subscribe((response: any) => {
      console.log(response['data']);
      // for (let i = 0; i < response.data.length; i++) {
      //   for (let j = 0; j < response.data[i]?.users.length; j++) {
      //     this.tableData.push({ cseName: response.data[i]['cseName'], cseId: response.data[i]['cseId'], users: response.data[i]?.users[j] });
      //   }
      // }

      response?.data.map((item) => this.tableData.push({ cseName: item.cse.name, facility_name: item.facility_name }));
      this.totalData = response?.total;
    })

  }

  tableSearch(event) {
    console.log(event.target.value);
    if (event.target.value != '') {
      sessionStorage.setItem("search_name_cse-facility_map", event.target.value);
      // this.cseParams = `cse_name=${event.target.value}`;
      this.cseParams = `facility_name=${event.target.value}`;
      this.downloadCSVParams = `${this.cseParams}&cseId=${this.queryParams.userId}`
    } else {
      this.cseParams = '';
      this.downloadCSVParams = `${this.cseParams}&cseId=${this.queryParams.userId}` 
      sessionStorage.removeItem('search_name_cse-facility_map');
    }

    // this.name = '';
    this.facility_name = '';
    // this.cseParams = '';
    // sessionStorage.removeItem('filter_name_cse-facility_map');
    sessionStorage.removeItem('filter_facility_name__cseFacilityMap');
    this.getCSEMappedListDeatils();
  }

  tableFilter() {
    this.showFilterContainer = !this.showFilterContainer;
    if (!this.showFilterContainer) {
      this.resetFilterClick();
    }
    this.searchFacility = '';
    sessionStorage.removeItem('search_name_cse-facility_map');
    this.getCSEMappedListDeatils();
  }

  searchFilterClick() {
    // console.log(
    //   this.name,
    //   this.facility_name,
    // );
    // sessionStorage.setItem('filter_name_cse-facility_map', this.name);
    sessionStorage.setItem('filter_facility_name__cseFacilityMap', this.facility_name);

    // this.cseParams = `cse_name=${this.name}&facility_name=${this.facility_name}`;
    this.cseParams = `facility_name=${this.facility_name}`;
    this.downloadCSVParams = `${this.cseParams}&cseId=${this.queryParams.userId}`
    sessionStorage.removeItem('search_name_cse-facility_map');
    this.searchFacility = '';
    this.getCSEMappedListDeatils();
  }

  resetFilterClick() {
    // this.name = '';
    this.facility_name = '';
    this.cseParams = '';
    this.downloadCSVParams = `${this.cseParams}&cseId=${this.queryParams.userId}`
    // sessionStorage.removeItem('filter_name_cse-facility_map');
    sessionStorage.removeItem('filter_facility_name__cseFacilityMap');
    this.getCSEMappedListDeatils();
  }

  filterEnterClick(event) {
    if (event.key === 'Enter') {
      console.log('enter');
      this.searchFilterClick();
    }
  }

  handlePagination(pageEvent) {
    // console.log('pagi value', pageEvent);
    this.cseParams = 'page=' + (pageEvent) + '&' + 'limit=10';
    this.downloadCSVParams = `${this.cseParams}&cseId=${this.queryParams.userId}`
    this.getCSEMappedListDeatils();
    // this.resetFilterClick();
  }

  // goToMappingForm() {
  //   this.router.navigateByUrl('admin/add-mapping-form');
  // }

  backIconClick() {
    this.location.back();
    sessionStorage.removeItem('search_name_cse-facility_map');
  }

}
